import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import OverviewScrollbarTrack from './OverviewScrollbarTrack.jsx';
export default class OverviewScrollbar extends Component {

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = {
            pageDefinitions: []
        }

        this.renderThumb = this.renderThumb.bind(this);
        this.renderTrack = this.renderTrack.bind(this);
        this.renderView = this.renderView.bind(this);

    }

    componentDidMount() {
        this.parsePdfInfo();
    }

    parsePdfInfo() {
        let allPromises = [];
        for (let index = 1; index <= this.props.pdfDocument.numPages; index++) {
            allPromises.push(this.props.pdfDocument.getPage(index));
        };
        Promise.all(allPromises).then((results) => {
            this.setState(
                {
                    pageDefinitions: results,
                }
            );
        });
    }

    renderThumb({ style, ...props }) {
        const finalStyle = {
            ...style,
            cursor: 'pointer',
            borderRadius: 3,
            border: "2px solid #007bff"
        };
        return <div style={finalStyle} {...props} />;
    }

    renderTrack({ style, ...props }) {
        return <OverviewScrollbarTrack
            style={style}
            pages={this.state.pageDefinitions}
            totalheight={this.state.totalHeight}
            highlights={this.props.highlights}
            searchResults={this.props.searchResults}
            {...props} />
    }

    renderView({ style, ...props }, ) {
        const finalStyle={
            ...style,
            width: "calc(100% - 50px)" 
          }
        return (
            <div
                className="box test pdf-content-pane"
                 style={finalStyle}
                {...props}/>
        );
    }

    render() {
         return (
            <Scrollbars
                style={{ width: "100%", height: "100%" }}
                renderThumbVertical={this.renderThumb}
                renderTrackVertical={this.renderTrack}
                renderView={this.renderView} 
                setViewRef={this.props.containerRefSetter}
            >
                {this.props.children}
            </Scrollbars>
        );
    }
}